import { VideoCtvRedux } from 'store-types';

export const selectSportByTag = (state: VideoCtvRedux, tag: string) => state.sports?.data[tag];

export const selectLeagueByTag = (state: VideoCtvRedux, tag: string) => state.leagues?.data[tag];

export const selectShowByTag = (state: VideoCtvRedux, tag: string) => state.shows?.data[tag];

export const selectLocalMarketByTag = (state: VideoCtvRedux, tag: string) =>
  state.localMarkets?.data[tag];

export const selectTitle = (data: { title?: string } | null | undefined) => {
  return data?.title;
};

export const selectDescription = (data: { description?: string } | null | undefined) => {
  return data?.description;
};

export const selectHeaderImage = (data: { header?: { animationUrl?: string; imageUrl?: string; backupImageUrl?: string } } | null | undefined) => {
  const isHeaderAnimated = !!data?.header?.animationUrl;

  return [
    data?.header?.animationUrl ||
      data?.header?.imageUrl ||
      data?.header?.backupImageUrl,
    isHeaderAnimated,
  ];
};

export const selectRowData = (data: { rows?: unknown[] } | null | undefined) => {
  return data?.rows;
};

export const selectRelatedLeagues = (data: { relatedLeagues?: unknown[] } | null | undefined) => {
  return data?.relatedLeagues;
};

export const selectRelatedShows = (data: { relatedShows?: unknown[] } | null | undefined) => {
  return data?.relatedShows;
};

export const selectRelatedMarkets = (data: { relatedMarkets?: unknown[] } | null | undefined) => {
  return data?.relatedMarkets;
};

export const selectLogoImage = (data: { thumbnail?: string } | null | undefined) => {
  return data?.thumbnail;
};
